<template>
    <div class="toast-container">
        <Toast
            v-for="toast in toasts"
            :key="toast.id"
            :id="toast.id"
            :message="toast.message"
            :duration="toast.duration"
            @dismiss="dismiss"
        />
    </div>
</template>

<script setup>
import Toast from './Toast.vue';
import { useToast } from '../composables/toaster.mjs';

const { toasts, dismiss } = useToast();
</script>
